import { xhrApiClient } from '@/config/xhrApiClient'
import { API_GIFT_EXCHANGE_MERCHANT } from '@/config/xhrApiClientRouteNames'
import { AxiosResponse } from 'axios'

export type TGiftExchangeMerchantQueryResult = AxiosResponse &
    TGiftExchangeMerchantQueryResultData

export type TGiftExchangeMerchantQueryResultData = {
    data: IGiftExchangeMerchant
}

export interface IGiftExchangeMerchant {
    error?: string | undefined
}

const postGiftExchangeMerchant = async (
    payload: any
): Promise<TGiftExchangeMerchantQueryResult> => {
    return await xhrApiClient.post(API_GIFT_EXCHANGE_MERCHANT, payload)
}

export default postGiftExchangeMerchant
